import {
  Component,
  Input,
  Output,
  EventEmitter,
  OnInit,
  ChangeDetectorRef,
} from '@angular/core';
import { ResourceData } from '../../../elements/resource/resource.types';
import { ShapeService } from '../../../element-editor/shape/shape.service';
import { IRIToId } from '../../../util/iri';
import { Observable } from 'rxjs';
import { Store } from '@ngrx/store';
import { selectCurrentFileID } from '../../../projects/project.selector';
import { map } from 'rxjs/operators';
import { ProjectService } from '../../../projects/project.service';
import { CanvasService } from '../../../services/canvas/canvas.service';
import {
  setResourceLabel,
  setSelectedScene,
  resetSelectedScenes,
  deleteScene,
} from '../../../element-editor/store/editor.actions';
import { selectSelectedScenes } from '../../../element-editor/store/selector/editor.selector';
@Component({
  selector: 'nw-slide-item',
  templateUrl: './slide-item.component.html',
  styleUrls: ['./slide-item.component.scss'],
})
export class SlideItemComponent implements OnInit {
  @Input() slide: ResourceData;
  @Input() index: number;
  @Input() newSceneMode = false;
  @Output() select = new EventEmitter<void>();

  private selectedScenes: Record<string, boolean> = {};
  get isSelected() {
    return !!this.selectedScenes?.[this.slide?.IRI];
  }
  imgLoaded: boolean;
  imgError: boolean;
  selected$: Observable<boolean>;
  constructor(
    private readonly shapeService: ShapeService,
    private readonly store: Store,
    private readonly projectService: ProjectService,
    private readonly cs: CanvasService,
    private cdr: ChangeDetectorRef,
  ) {
    this.cs.generalEventSubscribe('thumbnail-updated', IRI => {
      // -- // -- //
      /* console.log('slide-item > thumbnail-updated', {
        IRI,
        slide: this.slide?.IRI,
      }); */
      if (IRI === this.slide?.IRI) {
        // console.log('cdr-detectChanges');
        this.cdr.detectChanges();
      }
    });
  }

  addScene() {
    this.shapeService.addNewSceneAfter();
  }

  getThumbnailDataUrl() {
    // -- // -- // -- //
    // if (
    //   this.cs.currentFileID === IRIToId(this.slide.IRI)
    //   // &&
    //   // this.cs.thumbnailUpdated
    // ) {
    //   return this.cs.thumbnailDataUrl;
    // }
    // -- // -- // -- //

    return this.cs.thumbnailsByFile[this.slide.IRI];
    // `https://s3.eu-central-1.amazonaws.com/nowords-vlog.illustrations/${id}_thumbnail.png`
  }
  click(event: MouseEvent) {
    // New scene tile
    if (!this.slide) {
      this.projectService.addSceneAfter();
      return;
    }

    // Update selectedScenes based on shift state
    if (event?.shiftKey) {
      this.store.dispatch(setSelectedScene({ IRI: this.slide.IRI }));
    } else {
      this.store.dispatch(resetSelectedScenes({ IRI: this.slide.IRI }));
    }

    // Keep existing navigation/open behavior
    this.cs.currentRootFileID = IRIToId(this.slide.IRI);
    this.shapeService.openRootShape(this.slide.IRI);
  }

  updateLabel(label: string) {
    this.store.dispatch(setResourceLabel({ IRI: this.slide.IRI, label }));
  }
  isCurrentSceneIRI: boolean;

  ngOnInit(): void {
    if (!this.slide) {
      return;
    }
    // console.log('slide-item > ngOnInit', this.slide.IRI);
    this.selected$ = this.store
      .select(selectCurrentFileID)
      .pipe(map(id => id === IRIToId(this.slide.IRI)));

    this.selected$.subscribe(val => {
      this.isCurrentSceneIRI = val;
    });

    // Track selectedScenes for selected outline
    this.store
      .select(selectSelectedScenes)
      .subscribe(scenes => (this.selectedScenes = scenes));
  }

  onDelete() {
    this.store.dispatch(deleteScene({ IRI: this.slide.IRI }));
  }

  onSelect() {
    this.select.emit();
  }

  showDelete = false;
  on = false;

  hovered = false;

  onMouseOver() {
    this.hovered = true;
    setTimeout(() => {
      if (!this.on) {
        return;
      }
      this.showDelete = true;
    }, 1_500);
  }
  onMouseOut() {
    this.hovered = false;
    this.showDelete = false;
    this.on = false;
  }
}
